import { orderBy } from 'lodash'

import buildDocumentUrl from './buildDocumentUrl'

const buildDocumentItems = (documents, linkedDocuments) => {
  const attachmentItems = (documents || []).filter(Boolean).map((doc) => ({
    _type: 'attachment',
    name: doc.filename,
    url: buildDocumentUrl(doc.url),
  }))

  const linkedDocumentItems = (linkedDocuments || []).map((doc) => ({
    ...doc,
    _type: 'document',
  }))

  return orderBy(
    [...attachmentItems, ...linkedDocumentItems],
    [(i) => i?.name?.toLowerCase() || i?.documentVersion?.title?.toLowerCase()],
    ['asc'],
  )
}

export default buildDocumentItems
